import { render, staticRenderFns } from "./VeHrPerformance.vue?vue&type=template&id=dcb34034"
import script from "./VeHrPerformance.vue?vue&type=script&lang=js"
export * from "./VeHrPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports